export default __webpack_public_path__ + "static/media/finish.e2135cb1.svg";